import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  media: {
    height: "250px",
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  active: {
    borderBottom: "10px solid #02058e",
  },
  extras: {
    margin: "20px 10px",
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    margin: "25px 10px",
    fontFamily: "Poppins",
    fontWeight: "bolder",
  },
  footer: {
    display: "flex",
    padding: "15px",
    justifyContent: "space-between",
    alignItems: "center",
  },
});
